/**
 * Import all the common reducers/saga here and ALL project will get them
 * installed. I mean ALL so think about what you are adding!
 *
 * File ignores our codestyle for imports/exports and is set out like:
 * - import
 * - export
 * - import
 * - export
 * etc...
 */
import { __assign, __spreadArrays } from "tslib";
// Reducers
import sharedConfigReducers from '../../config/reducers';
import publicSessionReducers from '../../publicSession/reducers';
import watchButtonReducers from '../../WatchButton/redux/reducers';
import commentboxReducers from '../../CommentBox/reducers';
import mediaPopupReducers from '../../MediaPopup/reducers';
import modalReducers from '../../Modals/redux/reducer';
import notificationReducers from '../../Notifications/redux/reducer';
import MentionReducers from '../../DaEditorWrapper/AsyncHandlers/Mentions/reducers';
import editorsReducer from '../../DaEditorWrapper/redux/reducers';
import emoteSelectorReducers from '../../EmoteSelector/redux/reducers';
import journalEditPopupReducers from '../../WriterPopup/reducers';
import statusEditPopupReducers from '../../StatusEditPopup/reducers';
import pollEditPopupReducers from '../../PollEditPopup/redux/reducer';
import userAvatarReducers from '../../User/AvatarPopover/reducers';
import streamReducers from '../../Stream/reducers';
import { entitiesReducers } from '../entities';
import collectionPanelReducers from '../../CollectionPanel/redux/reducer';
import measuredCookieReducers from '../../Measured/redux/reducer';
import siteHeaderReducer from '../../SiteHeader/redux/reducer';
import flagsReducers from '../flags/reducer';
import firstTimeFlagsReducers from '../firstTimeFlags/reducers';
import duperbrowseReducers from '../../Duperbrowse/redux/reducer';
import deviationBackgroundReducer from '../../DeviationBackground/redux/reducer';
import moderationReducer from '../../Moderation/redux/reducer';
import deviationPageReducer from '../../DeviationPage/redux/reducer';
import addToGroupReducer from '../../AddToGroupsPanel/redux/reducer';
import artBrandedPopupReducer from '../../ArtBrandedPopup/redux/reducers';
import biReducer from '../../biLogger/redux/reducer';
import coreBadgeReducer from '../../coreBadge/redux/reducer';
import networkbarReducer from '../../NetworkBar/redux/reducer';
export var reducers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, sharedConfigReducers), publicSessionReducers), watchButtonReducers), streamReducers), entitiesReducers), commentboxReducers), mediaPopupReducers), modalReducers), notificationReducers), editorsReducer), MentionReducers), emoteSelectorReducers), journalEditPopupReducers), statusEditPopupReducers), pollEditPopupReducers), userAvatarReducers), collectionPanelReducers), flagsReducers), firstTimeFlagsReducers), siteHeaderReducer), measuredCookieReducers), duperbrowseReducers), deviationBackgroundReducer), moderationReducer), deviationPageReducer), addToGroupReducer), artBrandedPopupReducer), biReducer), coreBadgeReducer), networkbarReducer);
// Sagas
import publicSessionSaga from '../../publicSession/saga';
import commentBoxSaga from '../../CommentBox/saga';
import commentThreadSaga from '../../CommentThread/saga';
import emoteSelectorSaga from '../../EmoteSelector/redux/saga';
import watchButtonSaga from '../../WatchButton/redux/saga';
import journalEditPopupSaga from '../../WriterPopup/saga';
import statusEditPopupSaga from '../../StatusEditPopup/saga';
import mediaPopupSaga from '../../MediaPopup/saga';
import userAvatarSaga from '../../User/AvatarPopover/saga';
import streamSagas from '../../Stream/sagas';
import usersSaga from '../users/saga';
import deviationsSaga from '../deviations/saga';
import commissionsSaga from '../commissions/saga';
import loggedOutSaga from '../loggedout/saga';
import editorsSaga from '../../DaEditorWrapper/redux/saga';
import mentionSaga from '../../DaEditorWrapper/AsyncHandlers/Mentions/saga';
import deviationPasteSaga from '../../DaEditorWrapper/AsyncHandlers/DeviationPaste/saga';
import pollEditSaga from '../../PollEditPopup/redux/sagas';
import collectionPanelSaga from '../../CollectionPanel/redux/saga';
import firstTimeFlagsSaga from '../firstTimeFlags/saga';
import measuredCookieSaga from '../../Measured/redux/saga';
import siteHeaderSaga from '../../SiteHeader/redux/saga';
import duperbrowseSaga from '../../Duperbrowse/redux/saga';
import deviationBackgroundSaga from '../../DeviationBackground/redux/saga';
import moderationSaga from '../../Moderation/redux/saga';
import whoSaga from '../../Who/redux/saga';
import deviationPageSaga from '../../DeviationPage/redux/saga';
import addToGroupSaga from '../../AddToGroupsPanel/redux/saga';
import watchSuggestionsSaga from '../../WatchSuggestions/redux/saga';
import pollViewSaga from '../../PollView/redux/saga';
import artBrandedPopupSaga from '../../ArtBrandedPopup/redux/saga';
// import { modulelessPortfolioSaga as wixPortfolioSaga } from '../../WixPortfolio/redux/saga';
import recommendedGridSaga from '../../Torpedo/RecommendedTorpedo/saga';
import biSaga from '../../biLogger/redux/saga';
import hubSaga from '../hub/saga';
import modalSaga from '../../Modals/redux/saga';
import messagesSaga from '../messages/saga';
import userSearchFieldSaga from '../../UserSearchField/redux/saga';
import compliantLocalStorageSaga from '../../redux/compliantLocalStorage/saga';
import premiumFolderAccessSaga from '../../PremiumFolderAccessPopup/redux/saga';
import coreBadgeSaga from '../../coreBadge/redux/saga';
import networkbarSaga from '../../NetworkBar/redux/saga';
export var sagas = __spreadArrays([
    publicSessionSaga,
    commentBoxSaga,
    commentThreadSaga,
    usersSaga,
    deviationsSaga,
    commissionsSaga,
    emoteSelectorSaga,
    watchButtonSaga,
    journalEditPopupSaga,
    mediaPopupSaga,
    statusEditPopupSaga,
    userAvatarSaga,
    editorsSaga,
    mentionSaga,
    deviationPasteSaga,
    pollEditSaga,
    collectionPanelSaga,
    loggedOutSaga,
    firstTimeFlagsSaga,
    measuredCookieSaga,
    siteHeaderSaga,
    duperbrowseSaga,
    deviationBackgroundSaga,
    moderationSaga,
    whoSaga,
    deviationPageSaga,
    addToGroupSaga,
    watchSuggestionsSaga,
    pollViewSaga,
    artBrandedPopupSaga,
    recommendedGridSaga,
    biSaga,
    hubSaga,
    modalSaga,
    messagesSaga,
    userSearchFieldSaga,
    compliantLocalStorageSaga,
    premiumFolderAccessSaga,
    coreBadgeSaga,
    networkbarSaga
], streamSagas);
//# sourceMappingURL=index.js.map